import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "graphUp"
const GraphUpIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M18.998 8.068C19.306 7.79 19.78 7.815 20.058 8.123 20.333 8.431 20.31 8.905 20.001 9.183L15.757 13.002 12.757 10.378 9.019 13.742 8.519 13.326 6.725 11.831 5.7 12.6C5.368 12.848 4.899 12.78 4.65 12.45 4.402 12.118 4.47 11.649 4.8 11.4L6.774 9.92 7.23 10.298 8.981 11.758 12.743 8.372 15.743 10.997z" />
          <path
            fillRule="evenodd"
            d="M12.75 3H21C21.828 3 22.5 3.672 22.5 4.5V16.5C22.5 17.328 21.828 18 21 18H12.75V21H15V22.5H9V21H11.25V18H3C2.172 18 1.5 17.328 1.5 16.5V4.5C1.5 3.672 2.172 3 3 3H11.25V1.5H12.75zM3 16.5H21V4.5H3z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default GraphUpIcon
